__turbopack_context__.v({
  "accessibleText": "HeroCarousel-module-scss-module__x699zG__accessibleText",
  "active": "HeroCarousel-module-scss-module__x699zG__active",
  "carouselViewport": "HeroCarousel-module-scss-module__x699zG__carouselViewport",
  "carouselWrapper": "HeroCarousel-module-scss-module__x699zG__carouselWrapper",
  "controlButton": "HeroCarousel-module-scss-module__x699zG__controlButton",
  "eds-vector-image": "HeroCarousel-module-scss-module__x699zG__eds-vector-image",
  "imageList": "HeroCarousel-module-scss-module__x699zG__imageList",
  "imageListItem": "HeroCarousel-module-scss-module__x699zG__imageListItem",
  "next": "HeroCarousel-module-scss-module__x699zG__next",
  "prev": "HeroCarousel-module-scss-module__x699zG__prev",
  "sliderBar": "HeroCarousel-module-scss-module__x699zG__sliderBar",
  "sliderBarButton": "HeroCarousel-module-scss-module__x699zG__sliderBarButton",
  "sliderBarList": "HeroCarousel-module-scss-module__x699zG__sliderBarList",
});
